export default __webpack_public_path__ + "static/media/fMaltoBuza32.9b03c04e.png";